// The recipient form loads only this bundle — no dashboard Controller, Alpine or jQuery.
import "~/src/polyfills"

import { registerComponents } from "~/src/lib/reactComponentRegistry"

registerComponents({
  RecipientForm: () => import("~/src/components/RecipientForm/RecipientForm"),
})
